module.exports = __webpack_public_path__ + "img/Gunnar-Ploehn-920.a7f41f23.jpg";